/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function deleteMandate (id: number) {
  return rest.delete(`/api/mandates/${id}`)
}

export function fetchMandate (id: number): Promise<Mandate> {
  return rest.get(`/api/mandates/${id}`)
    .then((resp) => resp.json())
}

export function fetchMandateLastNumber (): Promise<{ data: { number: number } }> {
  return rest.get('/api/mandates/last-number')
    .then((resp) => resp.json())
}

export function findManyMandates (params: Record<string, any>): Promise<HalDocument<{
  mandates: Mandate[]
}>> {
  return rest.get(`/api/mandates?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function patchMandate (id: number, data: Partial<Mandate>) {
  return rest.patch(`/api/mandates/${id}`, {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}

export function postMandate (data: Partial<Mandate>) {
  return rest.post('/api/mandates', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}
